import { PATH_EMAIL_TYPES, PATH_ROOT } from "@/constants";
import { BreadcrumbItem } from "@/types/breadcrumb";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const emailTypesDirectoryPluralCount = 2;

export const useEmailTypeBreadcrumbs = (emailTypeName?: string) => {
  const { t } = useTranslation();

  return useMemo(() => {
    const items: BreadcrumbItem[] = [
      { label: t("breadcrumb.home"), href: PATH_ROOT },
      {
        label: t("emailTypes.title", {
          count: emailTypesDirectoryPluralCount,
        }),
        href: PATH_EMAIL_TYPES,
      },
    ];

    if (emailTypeName) {
      items.push({ label: emailTypeName });
    }

    return items;
  }, [emailTypeName, t]);
};
